const searchType = {
  nameAndDOB: 'Nama dan DOB',
  nameAndDOBWithAddressReturned: 'Nama dan DOB dengan Alamat Dikembalikan',
  idNumber: 'Nombor ID',
  idNumberWithAddressReturned: 'Nombor ID dengan Alamat Dikembalikan',
};

export default searchType;
